/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedTitle_itemSearch = {
    readonly totalResults: number | null;
    readonly pageType: string | null;
    readonly searchTerm: string | null;
    readonly searchCorrections: {
        readonly originalSearchTerm: string | null;
    } | null;
    readonly meta: {
        readonly header: string | null;
        readonly subHeader: string | null;
    } | null;
    readonly " $refType": "SbSharedTitle_itemSearch";
};
export type SbSharedTitle_itemSearch$data = SbSharedTitle_itemSearch;
export type SbSharedTitle_itemSearch$key = {
    readonly " $data"?: SbSharedTitle_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedTitle_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedTitle_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchTerm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "kind": "LinkedField",
      "name": "searchCorrections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalSearchTerm",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subHeader",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '093aae36b9c39bc1c99cdbe936f82fc5';
export default node;
